import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'micro',
        'detail',
        'caption',
        'ui',
        'code',
        'title',
        // The charter's type scale (@crow/ui's menus and fields), from @crow/theme's crowdex.css.
        'crow-label',
        'crow-compact',
        'crow-body',
        'crow-title',
        'crow-section',
      ],
      spacing: [
        'control-xs',
        'control-compact',
        'control-sm',
        'control-md',
        'control-lg',
        'control-px-xs',
        'control-px-sm',
        'control-px-md',
        'control-px-lg',
        'panel',
        'dialog',
      ],
      radius: [
        'control',
        'code',
        'tile',
        'card',
        'panel',
        'composer',
        'window',
        'pill',
        // The design system's (@crow/ui), from @crow/theme's crowdex.css.
        'crow-control',
        'crow-panel',
        'crow-window',
      ],
      shadow: ['crow-1', 'crow-2', 'crow-3'],
    },
    classGroups: {
      'font-size': [
        'type-ui',
        'type-caption',
        'type-code',
        'type-meta',
        'type-body',
        'type-section',
        'type-card-title',
        'type-section-title',
        'type-page-title',
        'type-reply',
        'type-conversation',
      ],
      z: ['z-panel', 'z-modal', 'z-popover', 'z-tooltip', 'z-toast', 'z-drag'],
      duration: ['duration-ui', 'duration-overlay'],
    },
  },
});

/** Merge conditional class names while resolving conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
